import { Link } from 'react-router-dom';
import MengniuCase from './components/MengniuCase';
import KangshifuCase from './components/KangshifuCase';
import WanglaojiCase from './components/WanglaojiCase';

export default function Cases() {
  return (
    <main>
      {/* Page Header */}
      <section className="relative pt-24 md:pt-32 pb-12 md:pb-16 bg-gradient-to-br from-[#1c1917] via-[#292524] to-[#1c1917] overflow-hidden">
        {/* 深色网格纹理 */}
        <div
          className="absolute inset-0 opacity-[0.04] pointer-events-none"
          style={{
            backgroundImage: 'linear-gradient(rgba(255,255,255,0.2) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.2) 1px, transparent 1px)',
            backgroundSize: '50px 50px',
          }}
        />
        {/* 金色/暖色光晕 - 右上 */}
        <div
          className="absolute -top-16 -right-16 w-[500px] h-[500px] rounded-full opacity-[0.15] pointer-events-none"
          style={{ background: 'radial-gradient(circle, rgba(245,158,11,0.3) 0%, transparent 70%)' }}
        />
        {/* 青色光晕 - 左下 */}
        <div
          className="absolute -bottom-24 -left-24 w-[400px] h-[400px] rounded-full opacity-[0.12] pointer-events-none"
          style={{ background: 'radial-gradient(circle, rgba(0,174,239,0.25) 0%, transparent 70%)' }}
        />
        {/* 装饰圆环 */}
        <div className="absolute top-[15%] right-[8%] w-[180px] h-[180px] rounded-full border border-[#f59e0b]/10 pointer-events-none" />
        <div className="absolute top-[20%] right-[10%] w-[120px] h-[120px] rounded-full border border-[#f59e0b]/10 pointer-events-none" />
        <div className="absolute bottom-[20%] left-[6%] w-[160px] h-[160px] rounded-full border border-[#00AEEF]/10 pointer-events-none" />
        {/* 浮动光点 */}
        <div className="absolute top-28 right-[22%] w-2 h-2 bg-[#f59e0b]/40 rounded-full animate-pulse pointer-events-none" />
        <div className="absolute bottom-24 left-[18%] w-1.5 h-1.5 bg-[#00AEEF]/30 rounded-full animate-pulse pointer-events-none" style={{ animationDelay: '1s' }} />
        <div className="absolute top-40 left-[35%] w-1 h-1 bg-white/20 rounded-full animate-pulse pointer-events-none" style={{ animationDelay: '2s' }} />
        {/* 装饰对角线 */}
        <div className="absolute top-[10%] right-[15%] w-[80px] h-px bg-gradient-to-r from-[#f59e0b]/10 to-transparent rotate-45 pointer-events-none origin-left" />
        <div className="absolute bottom-[15%] left-[12%] w-[80px] h-px bg-gradient-to-r from-[#00AEEF]/10 to-transparent rotate-45 pointer-events-none origin-left" />

        <div className="relative z-10 w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-3xl">
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
              实效见证
            </h1>
            <p className="text-sm md:text-base text-white/60 leading-relaxed">
              快消营销数字化的实战成果，来自蒙牛、康师傅、王老吉等头部品牌的一线经验
            </p>
          </div>
        </div>
      </section>

      {/* Case Studies */}
      <MengniuCase />
      <KangshifuCase />
      <WanglaojiCase />

      {/* CTA */}
      <section className="py-16 md:py-20 bg-primary">
        <div className="w-full px-4 md:px-8 lg:px-12 text-center">
          <h2 className="text-xl md:text-3xl font-bold text-white mb-4">
            想获得类似的数字化成果？
          </h2>
          <p className="text-sm md:text-base text-white/60 mb-8 max-w-xl mx-auto">
            预约同类方案诊断，让我们的顾问为您分析最适合的切入点。
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-8 py-3 bg-accent text-white font-semibold rounded-lg hover:bg-accent-dark transition-colors"
          >
            <i className="ri-calendar-check-line" />
            预约同类方案诊断
          </Link>
        </div>
      </section>
    </main>
  );
}